import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { DimensionOption } from './model/dimension-option-type';
import { dimensionStyles } from './styles/dimension-styles';
import { repeat } from 'lit/directives/repeat.js';
@customElement('dimension-selection-element')
export class DimensionSelectionElement extends LitElement {
    static styles = [dimensionStyles, css`
        li:host-context(.select-group-button:hover) {
            box-shadow: 1px 1px 1px #000;
        }
    `];

    @property({ type: Array })
    options: DimensionOption[] = [];

    render() {

    }

    handleOptionSelection(key: string, idx: number) {
        const dimensionSelectedEvent = new CustomEvent('option-selected', {
            detail: {
                key,
                idx,
            },
            composed: true,
            bubbles: true,
        });
        this.dispatchEvent(dimensionSelectedEvent);
    }
}